module.exports = __webpack_public_path__ + "media/images/emblems/Pully-coat_of_arms-a6468a37e15ea1b91459a10446eb097e.svg";